export default {
  title: "Image Gallery",
}
